import React from "react";
import SectionTitle from "../common/SectionTitle";

const FaqOneData = [
    {
        id: 1,
        faqTitle: 'Retrieve and Upload files',
        faqDesc:
            'Download files from the server and upload files to the server using SFTP, directly from your MCP Client.',
    },
    {
        id: 2,
        faqTitle: 'List files and folders',
        faqDesc:
            'Allows your Chat window access to folders and files. ',
    },
    {
        id: 4,
        faqTitle: 'Rename files and folders',
        faqDesc:
            "",
    },
    {
        id: 5,
        faqTitle: 'Delete files and folders',
        faqDesc:
            '',
    },
];




const FaqOne = () => {
    return (
        <>
            <section className="faq-section ptb-120 bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10 col-lg-6">
                            <SectionTitle

                                title="MCP Tools and Resources"

                                centerAlign
                            />
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-between">
                        <div className="col-lg-5 col-12">
                            <div className="faq-wrapper">
                                {FaqOneData.map((data, i) => (
                                    <div className="faq-item mb-5" key={i}>
                                        <h5>
                                            <span className="h3 text-primary me-2">{data.id}.</span>
                                            {data.faqTitle}
                                        </h5>
                                        <p>
                                            {data.faqDesc}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="text-center mt-4 mt-lg-0 mt-md-0">
                                <img
                                    src='/assets/blog/claude_desktop_4.png'
                                    className='img-fluid'
                                    alt='feature-img'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FaqOne;
